import type { CSSProperties } from "react";

import { Logo } from "@prophero-ds/cx-react";

import { useMediaQuery } from "@/hooks/useMediaQuery";
import { MEDIA_QUERY } from "@/utils/mediaQueries";

type PropHeroLogoProps = {
  className?: string;
};

/**
 * Logomark heights from Figma. CX Logo sizes stop at 24px, so the height is
 * set directly and the width follows the artwork ratio.
 * Desktop: 175×38. Mobile: 184×40.
 */
const DESKTOP_LOGO_STYLE = {
  "--cx-logo-height": "38px",
} as CSSProperties;

const MOBILE_LOGO_STYLE = {
  "--cx-logo-height": "40px",
} as CSSProperties;

function PropHeroLogo({ className }: PropHeroLogoProps) {
  const isMobile = useMediaQuery(MEDIA_QUERY.mobile);
  // CX tokens follow the OS colour scheme, so the logo does too.
  const isDark = useMediaQuery(MEDIA_QUERY.darkScheme);

  const name = isDark ? "logomark-white" : "logomark-black";

  return (
    <Logo
      name={name}
      data-logo={name}
      size={isMobile ? "4" : "5"}
      className={className}
      style={isMobile ? MOBILE_LOGO_STYLE : DESKTOP_LOGO_STYLE}
      role="img"
      aria-label="PropHero"
    />
  );
}

export default PropHeroLogo;
